/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_profile__tabs__information__form__email = /** @type {(inputs: {}) => string} */ () => {
	return `E-Mail`
};

const en_profile__tabs__information__form__email = /** @type {(inputs: {}) => string} */ () => {
	return `Email address`
};

const es_profile__tabs__information__form__email = /** @type {(inputs: {}) => string} */ () => {
	return `Dirección de correo electrónico`
};

const fr_profile__tabs__information__form__email = /** @type {(inputs: {}) => string} */ () => {
	return `Adresse e-mail`
};

const it_profile__tabs__information__form__email = /** @type {(inputs: {}) => string} */ () => {
	return `Indirizzo e-mail`
};

const nl_profile__tabs__information__form__email = /** @type {(inputs: {}) => string} */ () => {
	return `E-mailadres`
};

const pt_profile__tabs__information__form__email = /** @type {(inputs: {}) => string} */ () => {
	return `Endereço de e-mail`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__email = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.profile__tabs__information__form__email(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("profile__tabs__information__form__email", locale)
	if (locale === "de") return de_profile__tabs__information__form__email(inputs)
	if (locale === "en") return en_profile__tabs__information__form__email(inputs)
	if (locale === "es") return es_profile__tabs__information__form__email(inputs)
	if (locale === "fr") return fr_profile__tabs__information__form__email(inputs)
	if (locale === "it") return it_profile__tabs__information__form__email(inputs)
	if (locale === "nl") return nl_profile__tabs__information__form__email(inputs)
	return pt_profile__tabs__information__form__email(inputs)
};